import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import './plugins/toast-snackbar';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import store from './store/store';
import router from './Router';
import Zeedhi from '@zeedhi/vue';
import ZeedhiComponents from '@zeedhi/vuetify';
import '@zeedhi/common/dist/style.css';
import '@zeedhi/vuetify/dist/zd-style.css';
import '@/scss/main.scss';
import './plugins/axios';
import { format } from 'date-fns';
import Constants from './assets/ts/configuration/Constants';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
//import permission from '@/directives/permission';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import LocalizacaoController from './assets/ts/controller/LocalizacaoController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import CameraController from '@/assets/ts/controller/CameraController';

Vue.use(Zeedhi);
Vue.use(ZeedhiComponents);
//Vue.directive('permission', permission)

Vue.config.productionTip = false;

HttpRequest.setUrl(Constants.PROJECT_PATH + Constants.BACKEND_PATH);

// Tornando date-fns numa variável global
(window as any).format = format;

const initializeApp = () => {
  new Vue({
    store,
    vuetify,
    router,
    render: (h) => h(App),
  }).$mount('#app');
};

const initializeWebApp = async () => {
  try {
    await LocalizacaoController.init();
    initializeApp();
  } catch (error) {
    console.log('Erro ao inicializar a localização na web:', error);
  }
};

const initializeMobileApp = async () => {
  OfflineController.init();
  document.addEventListener('deviceready', initializeApp, false);
  try {
    await LocalizacaoController.init();

    try {
      await LocalizacaoController.checkGeoLocationMobile();
      OfflineController.setGeoLocationForOffline();
    } catch (error) {
      console.log('Solicitar acesso a Localização Mobile!', error);
    }

    await CameraController.checkCameraAccessMobile();
  } catch (error) {
    console.log(
      'Erro ao inicializar a localização no aplicativo móvel:',
      error
    );
  }
};

/**
 * Inicializa a aplicação.
 *
 * Se estiver em um dispositivo móvel, o início da aplicação deve aguardar o evento 'deviceready' do Cordova,
 * pois a aplicação depende de algumas funcionalidades específicas do Cordova.
 */
const initializeApplication = () => {
  if (OfflineController.isMobile()) {
    initializeMobileApp();
  } else {
    initializeWebApp();
  }
};

initializeApplication();